import React from "react";
import { Link } from "react-router-dom";
import styles from "../sections/GetInTouchVRSection.module.css";

const GetStarted = () => {

  return (
    <div className={styles.getStarted} style={{ backgroundImage: "url('/media/parallax_bg.png')" }}>
      <div className={styles.glassCard}>
        <h1 className={styles.getStarted1}>Get Started</h1>
        <p className={styles.experienceYourDream}>
          Experience your dream space before it’s built with our 3D rendering and
          walkthrough video services. Contact ShaKa Design Lab today to learn more
          and schedule a consultation. Let us bring your vision to life with
          unparalleled clarity and detail.
        </p>
        <Link to="/contact" className={styles.getInTouchBtn} style={{ textDecoration: 'none' }}>
          GET IN TOUCH
        </Link>
      </div>
    </div>
  );
};

export default GetStarted;
